import { defineModule } from '@portal/kernel';

/** File storage shared by modules (docs/design/P5_PARTNERS.md §2.1). Owning modules decide who may read. */
export const manifest = defineModule({
  key: 'core-files',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Tệp tin', en: 'Files' },
  description: {
    vi: 'Lưu trữ file dùng chung (hợp đồng scan, ảnh…); quyền xem do module sở hữu quyết định.',
    en: 'Shared file storage (scanned contracts, images…); the owning module decides who may read.',
  },
  dependsOn: ['core-system', 'core-identity'],
  database: { schema: 'core_files' },
});
